import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { ApmBase, init } from '@elastic/apm-rum';
import { environment } from 'src/environments/environment';
import { ApmService } from '@elastic/apm-rum-angular';

export const KNOWN_ERRORS = {
  genericError: 'Report caught error to Elastic',
  tradeError: 'Caught trade error',
  progressEvent: 'Caught ProgressEvent error',
};

const ENV_NAME = {
  development: 'Development',
  stage: 'Staging',
  production: 'Production',
};

const ENV_ID = {
  development: 'dev',
  stage: 'stg',
  production: 'prd',
};

const SERVICE_NAME = 'gbm-cb-homebroker-trading-rum';
// prettier-ignore
const SERVICE_URL = 'https://ab75d046dcbc4ddd84ae4872708c517e.apm.us-east-1.aws.cloud.es.io:443';
const SERVICE_ENV_ID = ENV_ID[environment.appConfigurationEnvironment];
const SERVICE_ENV = ENV_NAME[environment.appConfigurationEnvironment];

declare const SERVICE_VERSION: string;

@Injectable()
export class LoggerService {
  private apm: ApmBase;
  private APP_ID = 16;

  constructor(service: ApmService) {
    this.apm = service.init({
      serviceName: `${SERVICE_NAME}-${SERVICE_ENV_ID}`,
      serverUrl: SERVICE_URL,
      serviceVersion: SERVICE_VERSION,
      environment: SERVICE_ENV,
      active: true,
    });
  }

  setEvent(eventName: string, requestObject: any, customAttributes?: any) {
    const fixedRequestObject: any = {
      ...requestObject,
    };

    if (requestObject instanceof ProgressEvent) {
      const xhrURL = this.getMessageFromProgressEvent(requestObject);
      fixedRequestObject.xhrURL = xhrURL;
    }

    this._doSetEvent(eventName, { ...fixedRequestObject, ...customAttributes });
  }

  buildHash(
    timestamp: any,
    contrato: any,
    issue: any,
    titles: any,
    orden: any,
  ) {
    return `${this.APP_ID}${timestamp}${contrato}${issue.replace(
      ' ',
      '',
    )}${titles}${orden}`;
  }

  setError(error: Error, customAttributes: any = {}) {
    this.apm.captureError(error, { labels: customAttributes });
  }

  private _doSetEvent(eventName: string, requestObject: any) {
    try {
      const startedTime = moment(requestObject.startedTime || new Date());
      const currentTime = moment(new Date());

      requestObject.startedTime = startedTime.format('YYYY-MM-DD hh:mm:ss.SSS');
      requestObject.finishedTime = currentTime.format(
        'YYYY-MM-DD hh:mm:ss.SSS',
      );

      this.apm.captureError(new Error(eventName), {
        labels: requestObject,
      });
    } catch (e) {
      console.log(e);
    }
  }

  private getMessageFromProgressEvent(value: ProgressEvent) {
    const xhrURL =
      (value.target && (value as any).target.__zone_symbol__xhrURL) ||
      'Unknown xhrURL';
    const errorMessage = `ProgressEvent at ${xhrURL.replace(/\//g, '|')}`;
    return errorMessage;
  }
}
